import axios from "axios";

const apiUrl = "https://api.digidoc.co.in"; // Replace with your actual API URL
const API = axios.create({  });

// Attach token and handle request
API.interceptors.request.use(
  async (config) => {
    const authToken = localStorage.getItem("token");
    const parsedAuthToken = JSON.parse(authToken); // Assuming the token is stored as a stringified JSON

    // Log token and userId for debugging
    console.log("Sending Token:", parsedAuthToken);

    // Attach token in the Authorization header
    if (parsedAuthToken) {
      config.headers.Authorization = `Bearer ${parsedAuthToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response for token refresh or expiry
API.interceptors.response.use(
  (response) => {
    // If a new token is returned in the response, save it
    if (response.data.token) {
      console.log("Refreshing Token:", response.data.token);
      localStorage.setItem("token", JSON.stringify(response.data.token));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Log the error for debugging
      console.error("Authorization error:", error.response);

      // Remove token and user data
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("loggedIn");

      // Redirect to login page
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

// API utility functions
export const GetAPI = async (url, callback) => {
  await API.get(apiUrl + url)
    .then((response) => callback(response.data))
    .catch((error) => console.error("GET API Error:", error));
};

export const PostAPI = async ({ url, data }, callback) => {
  await API.post(apiUrl + url, data)
    .then((response) => {
      console.log("here", response);
      callback(response?.data);
    })
    .catch((error) => {
      console.log("here 1",);
      callback(error?.response?.data)});
};

export const PatchAPI = async ({ url, data }, callback) => {
  await API.patch(apiUrl + url, data)
    .then((response) => callback(response.data))
    .catch((error) => callback(error.response.data));
};

export const DeleteAPI = async ({ url, data }, callback) => {
  await API.delete(apiUrl + url, { data })
    .then((response) => callback(response.data))
    .catch((error) => callback(error.response.data));
};

export const PutAPI = async ({ url, data }, callback) => {
  await API.put(apiUrl + url, data)
    .then((response) => callback(response?.data))
    .catch((error) => {
      callback(error);
      console.error("PUT API Error:", error);
    });
};

export default API;
